const nav_bar = {
	overview: "Overzicht",
};

export default nav_bar;
